module.exports = __webpack_public_path__ + "static/me-e6e61350f17601bfa6203f938961dfd8.png";